export default __webpack_public_path__ + "static/media/telco_red.82a30c60.svg";